<div class="sidenav">
  <mat-list>
    <a mat-list-item
       routerLink="how-to"
       routerLinkActive="active"
       class="sidenav--list-link"
       (click)="onNavigate()">
      <mat-icon matListItemIcon>school</mat-icon>
      <div matListItemTitle>How-To-Use</div>
    </a>
    <a mat-list-item
       routerLink="changelog"
       routerLinkActive="active"
       class="sidenav--list-link"
       (click)="onNavigate()">
      <mat-icon matListItemIcon>quiz</mat-icon>
      <div matListItemTitle>Changelog</div>
    </a>
    <a mat-list-item
       routerLink="help"
       routerLinkActive="active"
       class="sidenav--list-link"
       (click)="onNavigate()">
      <mat-icon matListItemIcon>school</mat-icon>
      <div matListItemTitle>Help</div>
    </a>
  </mat-list>
</div>
